export const APIROUTES = {
    get DEFAULT() { return '/rest'},
    REPORT: {        
        get BASE() { return `${APIROUTES.DEFAULT}/report`; },
        get TRACKING_REPORT_INITIAL() { return `${APIROUTES.REPORT.BASE}/get_initial_tracking_data`; },
        get TRACKING_REPORT_DETAILS() { return `${APIROUTES.REPORT.BASE}/update_tracking_data_with_details`; },
    },
    USER: {
        get BASE() { return `${APIROUTES.DEFAULT}`; },
        get GET_USER_DETAILS() { return `${APIROUTES.USER.BASE}/get_user_details`; },
        get GET_USER_LOCALIZATION() { return `${APIROUTES.USER.BASE}/get_user_localization`; },     
        GET_MANAGERS_FOR_TENANT(tenantId: string) { return `${APIROUTES.USER.BASE}/get_manager_users/${tenantId}`; },     
    },
    USE_CASE: {
        get BASE() { return `${APIROUTES.DEFAULT}/use-case`; },
        get LISTING() { return `${APIROUTES.USE_CASE.BASE}/get-use-case-list`; },
        LISTING_FOR_CLAIMAINT(id: any) { 
            return `${APIROUTES.USE_CASE.BASE}/get_use_case_list_by_claimant/${id}`; 
        },      
        get LISTING_POPULATED() { return `${APIROUTES.USE_CASE.BASE}/populate-use-case-list`; },
        get AVAILABLE_USE_CASE_TEMPLATE() { return `${APIROUTES.USE_CASE.BASE}/get-use-case-templates`; },
        get USE_CASE_TEMPLATE_DATA() { return `${APIROUTES.USE_CASE.BASE}/get-use-case-template`; },
        get USE_CASE_CREATE() { return `${APIROUTES.USE_CASE.BASE}/add-use-case`; },
        get USE_CASE_UPDATE() { return `${APIROUTES.USE_CASE.BASE}/update-use-case`; },
        get USE_CASE_FILE_UPLOAD() { return `${APIROUTES.USE_CASE.BASE}/upload-use-case-file`; },
        get ASSOCIATE_USE_CASE_ACCESS() { return `${APIROUTES.USE_CASE.BASE}/associate-use-case-access`; },
        get USE_CASE_NOTE_CREATE() { return `${APIROUTES.USE_CASE.BASE}/add-use-case-note`; },
        get UPDATE_USE_CASE_NOTE_ACCESS() { return `${APIROUTES.USE_CASE.BASE}/update-use-case-note-access`; },
        get USE_CASE_DETAILS_DATA() { return `${APIROUTES.USE_CASE.BASE}/get-use-case`; },
        get USE_CASE_FILE_ANSWER() { return `${APIROUTES.USE_CASE.BASE}/get-use-case-file`; },
    }, 
    TENANT_TYPE: {
        get BASE() { return `${APIROUTES.DEFAULT}/tenant-type`; },
        get LISTING() { return `${APIROUTES.TENANT_TYPE.BASE}/get_tenant_types`; }, 
        AVAILABLE_CASE_TEMPLATE(id: number) { 
            return `${APIROUTES.TENANT_TYPE.BASE}/${id}/get_case_templates`; 
        },
        AVAILABLE_CLAIM_TEMPLATE(id: number) { 
            return `${APIROUTES.TENANT_TYPE.BASE}/${id}/get_claim_templates`; 
        }
    }
}